var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('section',{staticClass:"product"},[_c('div',{key:"product_page",staticClass:"product_page page-bottom"},[_c('SubTitle',{attrs:{"TitleName":'http://d-mebius.com/miasmabreaker/assets/index_products.png',"AltText":'商品情報'}}),_c('SoftProduct')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }